import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { useStyles } from './MainLogo.style';

interface MainLogoProps {
  logoPath: string;
}

const MainLogo: React.FC<MainLogoProps> = (props) => {
  const { logoPath } = props;

  const isMobile = useMediaQuery('(max-width:600px)');
  const classes = useStyles({ isMobile });

  return <img src={logoPath} alt="main-logo" className={classes.logo} />;
};

export default MainLogo;
